export class Messages {
  public static DATE_ERROR = 'Please enter a valid date (MM/DD/YYYY).';
  public static FUTURE_DATE_ERROR = 'Please enter a date (MM/DD/YYYY) today\'s date or later.';
  public static YEAR_ERROR = 'Please enter a valid year (YYYY).';
  public static SELECT_ERROR = 'Please select a value.';
  public static EMAIL_ERROR = 'Please enter a valid email address.';
  public static PHONE_ERROR = 'Please enter a valid phone number.';
  public static FORM_ERROR = 'There are invalid or incomplete form entries. Please make corrections to continue.';
  public static SERVER_ERROR = 'The application is experiencing technical difficulties. Please try again later.';
  public static REQUIRED_ERROR = 'This field is required.';

  public static NOT_AUTHENTICATED_ERROR = 'You are not authenticated.';

  public static STANDARD_SPINNER_MESSAGE = 'Processing...';
}
